<!--  -->
<template>
  <div class="login-box">
    <div class="bg" @click="closeLogin"></div>
    <div :class="[fromType=='center'?'content-center':'content']">
      <div class="content-box">
        <div class="content-box-header">
            <span>支付</span>
            <img src="../../assets/images/close.png" alt="" class="close-icon" @click="closeLogin"/>
        </div>
        <div class="login-wrapper">
            <div class="pay-title">请使用支付宝扫描二维码进行支付</div>
            <img src="../../assets/register/wechatPay.jpg" class="pay-img"/>
        </div> 
        <div class="pay-way">
              <span>支付方式：支付宝</span>
              <!-- <img src="http://tianlei-live.oss-cn-shenzhen.aliyuncs.com/alldata/zifu/wx.jpg"/> -->
            </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: '',
  data () {
    return {
    }
  },

  props: ['fromType'],

  watch: {},

  components: {},

  computed: {},

  created () {},
  mounted(){
  
  },
  methods: {
    closeLogin(){
      this.$emit('closeLogin')
    },
  }
}

</script>
<style lang='scss' scoped>
.login-box {
  position:fixed;
  top:0px;
  left:0px;
  width:100%;
  height:100vh;
  z-index:100;
}
.bg{
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.2);
}
.content-center{
  position:fixed;
  height:440px;
  width:650px;
  background-color:#fff;
  left:50%;
  top:180px;
  transform: translateX(-50%);
}
.content{
  position:fixed;
  height:440px;
  width:650px;
  background-color:#fff;
  left:50%;
  top:50%;
  transform: translate(-50%,-50%);
}
.content-box{
  width:100%;
  height:100%;
  position: relative;
  box-sizing: border-box;
  // display: flex;
  // justify-content: center;
  .content-box-header {
    width: 100%;
    text-align: center;
    font-size:14px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding:20px;
    box-sizing: border-box;
    height:40px;
    background-color:#ffdfea36;
    border-bottom:1px solid #eee;
  }
}

.close-icon{
  width:20px;
  width:20px;
  cursor: pointer;
}
.login-wrapper {
  margin:20px auto 20px;
  background-color:#ffdfea96;
  text-align: left;
  font-size: 20px;
  width:600px;
  height:300px;
  text-align: center;
  .pay-title{
    font-size:16px;
    padding-top:30px;
    padding-bottom:20px;
  }
  .pay-img{
    width:200px;
    height:200px;
  }
}
.pay-way{
  font-size:16px;
  display: flex;
  align-items: center;
  justify-content: center;
    img{
        width:123.75px;
        height:45.9px;
      }
  }

</style>


// WEBPACK FOOTER //
// src/components/payBox/index.vue